import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'interventions',
    children: [
      {
        path: '',
        name: 'interventions.index',
        component: () => import('@/modules/interventions/views/InterventionsIndex.vue')
      },
      {
        path: ':interventionId',
        name: 'interventions.show',
        component: () => import('@/modules/interventions/views/InterventionShow.vue'),
        props: true
      },
      {
        path: ':interventionId/edit',
        name: 'interventions.update',
        component: () => import('@/modules/interventions/views/InterventionEdit.vue'),
        redirect: { name: 'intervention.structure' },
        props: true,
        children: [
          {
            path: 'structure',
            name: 'intervention.structure',
            component: () =>
              import('@/modules/interventions/views/InterventionStructureEditor.vue')
          },
          {
            path: 'settings',
            name: 'intervention.settings',
            component: () =>
              import('@/modules/interventions/views/ContainerGroupSettings.vue')
          },
          {
            path: 'translation',
            name: 'intervention.translation',
            component: () =>
              import('@/modules/interventions/views/ContainerGroupTranslation.vue'),
            props: { labelScope: 'intervention' }
          }
        ]
      }
    ]
  },
  {
    path: 'intervention-instances',
    children: [
      {
        path: ':instanceId',
        name: 'interventionInstances.show',
        component: () => import('@/modules/interventions/views/InterventionInstanceShow.vue'),
        props: true
      }
    ]
  },
  {
    path: 'modules',
    children: [
      {
        path: ':moduleId',
        name: 'modules.show',
        component: () => import('@/modules/interventions/views/ModuleShow.vue'),
        props: true
      },
      {
        path: ':moduleId/edit',
        name: 'modules.update',
        component: () => import('@/modules/interventions/views/ModuleEdit.vue'),
        redirect: { name: 'module.designer' },
        props: true,
        children: [
          {
            path: 'designer',
            name: 'module.designer',
            component: () =>
              import('@/modules/interventions/views/ModuleDesigner.vue')
          },
          {
            path: 'settings',
            name: 'module.settings',
            component: () => import('@/modules/interventions/views/ModuleSettings.vue')
          },
          {
            path: 'translation',
            name: 'module.translation',
            component: () =>
              import('@/modules/interventions/views/ModuleTranslation.vue')
          }
        ]
      }
    ]
  }
]

export default routes
